// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1xQRc","content":"ManualTimeModal_content__3U0oA"};